"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Datagrid;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _core = require("@material-ui/core");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _icons = require("@material-ui/icons");

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _DataGridFooter = require("./DataGridFooter/DataGridFooter");

var _GridHeader = require("./GridHeader/GridHeader");

var _Datagrid = require("./Datagrid.style");

var _ServerPagination = require("./DataGridFooter/ServerPagination");

var _Input = _interopRequireDefault(require("../Input/Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Datagrid(_ref) {
  var renderRow = _ref.renderRow,
      _ref$headings = _ref.headings,
      headings = _ref$headings === void 0 ? [] : _ref$headings,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      selectable = _ref.selectable,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? {} : _ref$selected,
      setSelected = _ref.setSelected,
      editable = _ref.editable,
      deletable = _ref.deletable,
      completable = _ref.completable,
      exportable = _ref.exportable,
      link = _ref.link,
      title = _ref.title,
      actions = _ref.actions,
      hideSelect = _ref.hideSelect,
      handleReject = _ref.handleReject,
      expandable = _ref.expandable,
      handleExpand = _ref.handleExpand,
      _ref$expandHeader = _ref.expandHeader,
      expandHeader = _ref$expandHeader === void 0 ? "Modify" : _ref$expandHeader,
      _ref$expandIcon = _ref.expandIcon,
      expandIcon = _ref$expandIcon === void 0 ? /*#__PURE__*/_react.default.createElement(_icons.Edit, {
    fontSize: "small",
    className: "action-icon",
    "data-testid": "expand"
  }) : _ref$expandIcon,
      withIcon = _ref.withIcon,
      loading = _ref.loading,
      sharable = _ref.sharable,
      handleshare = _ref.handleshare,
      rejectable = _ref.rejectable,
      handleDelete = _ref.handleDelete,
      _ref$paginationOption = _ref.paginationOptions,
      paginationOptions = _ref$paginationOption === void 0 ? [5, 10, 20] : _ref$paginationOption,
      _ref$paginationDefaul = _ref.paginationDefaultValue,
      paginationDefaultValue = _ref$paginationDefaul === void 0 ? 10 : _ref$paginationDefaul,
      renderHeaderWithSorting = _ref.renderHeaderWithSorting,
      _ref$headerClassName = _ref.headerClassName,
      headerClassName = _ref$headerClassName === void 0 ? "grid-header" : _ref$headerClassName,
      serverPage = _ref.serverPage,
      setServerPage = _ref.setServerPage,
      pageSize = _ref.pageSize,
      setPageSize = _ref.setPageSize,
      isServerPagination = _ref.isServerPagination,
      _ref$totalRecords = _ref.totalRecords,
      totalRecords = _ref$totalRecords === void 0 ? 0 : _ref$totalRecords,
      editableCell = _ref.editableCell,
      editableCellName = _ref.editableCellName,
      editableCellHeader = _ref.editableCellHeader,
      handleCellBlur = _ref.handleCellBlur,
      sliderCell = _ref.sliderCell,
      sliderCellName = _ref.sliderCellName,
      sliderCelleader = _ref.sliderCelleader,
      handleSliderChange = _ref.handleSliderChange,
      _ref$sliderColor = _ref.sliderColor,
      sliderColor = _ref$sliderColor === void 0 ? "primary" : _ref$sliderColor;

  var _useState = (0, _react.useState)(paginationDefaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      perPage = _useState2[0],
      setPerPage = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      _useState4 = _slicedToArray(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      editMode = _useState6[0],
      setEditMode = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      cellValue = _useState8[0],
      setCellValue = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      editableItem = _useState10[0],
      setEditableItem = _useState10[1];

  var show = isServerPagination ? data : data.slice((page - 1) * perPage, page * perPage);
  var allSelected = show.every(function (_ref2) {
    var id = _ref2.id;
    return selected[id];
  });

  var renderHeader = function renderHeader(headings) {
    return headings.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          header = _ref4[1];

      return /*#__PURE__*/_react.default.createElement("th", {
        key: key,
        className: headerClassName
      }, header);
    });
  };

  var handleChangePerPage = function handleChangePerPage(e) {
    setPerPage(e.target.value);
    setPageSize && setPageSize(e.target.value);
    setPage(1);
    setServerPage && setServerPage(0);
  };

  var handleChangePage = function handleChangePage(_, page) {
    setPage(page);
    setServerPage && setServerPage(page);
  };

  var handleChangeSelected = (0, _react.useCallback)(function (id) {
    return setSelected(_objectSpread({}, selected, _defineProperty({}, id, !selected[id])));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [selected]);
  var handleSelectAll = (0, _react.useCallback)(function () {
    if (allSelected) {
      setSelected({});
    } else {
      setSelected(show.reduce(function (acc, item) {
        acc[item.id] = true;
        return acc;
      }, {}));
    } // eslint-disable-next-line

  }, [allSelected, show]);

  var handleCellChange = function handleCellChange(e) {
    setCellValue(e.target.value);
  };

  var handleEditable = function handleEditable(id) {
    return function () {
      setCellValue((data.find(function (item) {
        return (item || {}).id === id;
      }) || {})[editableCellName]);
      setEditMode(true);
      setEditableItem(id);
    };
  };

  var _onBlur = function onBlur(cellValue, item) {
    setEditMode(false);
    handleCellBlur(cellValue, item);
  };

  var renderCellValue = function renderCellValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    if (!value) return value;else {
      return value.length > 15 ? value.slice(0, 15) + "..." : value;
    }
  };

  var renderEditableCell = function renderEditableCell() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var rowStyle = item[editableCellName] ? {
      paddingTop: "17px",
      paddingBottom: "17px"
    } : {
      paddingTop: "26px",
      paddingBottom: "27px"
    };
    return editMode && item.id === editableItem ? /*#__PURE__*/_react.default.createElement("td", {
      style: {
        width: "150px",
        overflow: "hidden"
      }
    }, /*#__PURE__*/_react.default.createElement(_Input.default, {
      value: cellValue,
      onChange: handleCellChange,
      onBlur: function onBlur() {
        return _onBlur(cellValue, item);
      },
      autoFocus: true
    })) : /*#__PURE__*/_react.default.createElement("td", {
      style: _objectSpread({}, rowStyle, {
        overflow: "hidden",
        width: "150px"
      }),
      onClick: handleEditable(item.id)
    }, renderCellValue(item[editableCellName]));
  };

  var renderSliderCell = function renderSliderCell() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/_react.default.createElement("td", {
      className: "slider-cell"
    }, /*#__PURE__*/_react.default.createElement(_core.Slider, {
      value: item[sliderCellName] || 0,
      onChange: function onChange(event, newValue) {
        return handleSliderChange(event, newValue, item);
      },
      size: "small",
      valueLabelDisplay: "auto",
      style: {
        color: sliderColor
      }
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_Datagrid.DatagridView, null, (title || actions) && /*#__PURE__*/_react.default.createElement(_GridHeader.GridHeader, {
    title: title,
    actions: actions
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "grid-wrapper",
    "data-testid": "datagrid"
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: "grid-table",
    style: {
      minWidth: "700px"
    }
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "table-row"
  }, selectable && /*#__PURE__*/_react.default.createElement("th", {
    className: "main-checkbox column-center"
  }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    checked: allSelected,
    onChange: handleSelectAll,
    "data-testid": "checkbox"
  })), withIcon && /*#__PURE__*/_react.default.createElement("th", null), renderHeaderWithSorting ? renderHeaderWithSorting(headings, data) : renderHeader(headings), sliderCell && /*#__PURE__*/_react.default.createElement("th", {
    className: "editable-header"
  }, sliderCelleader), editableCell && /*#__PURE__*/_react.default.createElement("th", {
    className: "editable-header"
  }, editableCellHeader), editable && /*#__PURE__*/_react.default.createElement("th", {
    className: headerClassName
  }, "Edit"), deletable && /*#__PURE__*/_react.default.createElement("th", {
    className: headerClassName
  }, "Delete"), rejectable && /*#__PURE__*/_react.default.createElement("th", {
    className: headerClassName
  }, "Reject"), completable && /*#__PURE__*/_react.default.createElement("th", {
    className: "".concat(headerClassName, " column-center")
  }, "Complete"), expandable && /*#__PURE__*/_react.default.createElement("th", {
    className: "".concat(headerClassName, " column-center")
  }, expandHeader), sharable && /*#__PURE__*/_react.default.createElement("th", {
    className: headerClassName
  }, "Share"))), loading ? /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, selectable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), withIcon && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), headings.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("td", {
      key: item[0]
    }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
      variant: "rect",
      width: "100%",
      height: 520
    }));
  }), sliderCell && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), editableCell && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), editable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), deletable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), rejectable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), completable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), exportable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), expandable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })), sharable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "100%",
    height: 520
  })))) : /*#__PURE__*/_react.default.createElement("tbody", null, show.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: item.id,
      className: "table-row"
    }, selectable && /*#__PURE__*/_react.default.createElement("td", {
      className: "selectable column-center"
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: Boolean(selected[item.id]),
      onChange: function onChange() {
        return handleChangeSelected(item.id);
      },
      "aria-label": "checkbox"
    })), withIcon && /*#__PURE__*/_react.default.createElement("td", null, item.icon), renderRow(headings, item), sliderCell && renderSliderCell(item), editableCell && renderEditableCell(item), editable && /*#__PURE__*/_react.default.createElement("td", {
      className: ""
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      to: "/".concat(link, "/").concat(item.id),
      "data-testid": "edit"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "action-button"
    }, /*#__PURE__*/_react.default.createElement(_icons.Edit, {
      fontSize: "small",
      className: "action-icon"
    })))), deletable && /*#__PURE__*/_react.default.createElement("td", {
      className: ""
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "action-button",
      onClick: function onClick() {
        return handleDelete(item.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
      fontSize: "small",
      color: "primary",
      "data-testid": "delete",
      className: "action-icon"
    }))), rejectable && /*#__PURE__*/_react.default.createElement("td", {
      className: ""
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "action-button",
      onClick: function onClick() {
        return handleReject(item.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
      fontSize: "small",
      color: "primary",
      "data-testid": "delete",
      className: "action-icon"
    }))), completable && /*#__PURE__*/_react.default.createElement("td", {
      className: "completable column-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "action-button"
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      "data-testid": "complete"
    }))), exportable && /*#__PURE__*/_react.default.createElement("td", {
      className: ""
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "action-button"
    }, /*#__PURE__*/_react.default.createElement(_icons.Input, {
      "data-testid": "export"
    }))), expandable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "action-button",
      onClick: handleExpand(item.id)
    }, expandIcon)), sharable && /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
      className: "share-button",
      "data-testid": "share",
      onClick: function onClick() {
        return handleshare(item.id);
      }
    }, "Share")));
  })))), isServerPagination ? /*#__PURE__*/_react.default.createElement(_ServerPagination.ServerPagination, {
    handleChangePerPage: handleChangePerPage,
    perPage: pageSize,
    page: serverPage,
    handleChangePage: handleChangePage,
    loading: loading,
    data: show,
    totalRecords: totalRecords
  }) : /*#__PURE__*/_react.default.createElement(_DataGridFooter.DataGridFooter, {
    data: data,
    paginationOptions: paginationOptions,
    handleChangePerPage: handleChangePerPage,
    perPage: perPage,
    page: page,
    hideSelect: hideSelect,
    handleChangePage: handleChangePage
  }));
}

//# sourceMappingURL=Datagrid.js.map